import type { RawGrant } from './types';

/**
 * Static translation table for the legacy colon grammar (Addendum A.2).
 *
 * The colon forms (`is:ListPolicies`, `as:*`, `pb:*`) are still issued by the auth service for
 * roles created before the dotted grammar existed. They are translated here — once, in one
 * place — and may never be declared by new code. Retiring them is backend role-data cleanup
 * tracked outside this repository (Addendum, Part C).
 *
 * Seeded with the entries the legacy corpus exercises. An unmapped colon grant is *rejected and
 * logged*, never silently dropped, so a role depending on one shows up in the inspector.
 */
export const COLON_TRANSLATION_TABLE: Readonly<Record<string, readonly RawGrant[]>> = {
  'as:*': ['*.*'],
  'is:*': ['*.*'],
  'is:ListPolicies': ['policy-management.policies.view'],
  'is:ViewPolicy': ['policy-management.policies.view'],
  'is:CreatePolicy': ['policy-management.policies.create'],
  'is:UpdatePolicy': ['policy-management.policies.update'],
  'is:ListProducts': ['policy-management.products.view'],
  'is:ViewProduct': ['policy-management.products.view'],
  'is:ListInvoices': ['billing-management.invoices.view'],
  'pb:*': ['partner-management.*'],
};

export const isColonGrant = (grant: RawGrant): boolean => grant.includes(':');
